import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { SingleSelectDropdown, DROPDOWN_TYPE } from "widgets/singleselect";
import { DropdownItem } from "widgets/inputs";

import { Base } from "../base";
import { Boolean as BooleanReadOnly } from "../../renderers/boolean";

import styles from "./boolean.css";

export function Boolean(props) {
  const { column, value, pos, row } = props;
  const baseRef = useRef(null);
  const selectRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value ? "true" : "false");
  const dataSource = [
    { _id: "true", label: "Yes" },
    { _id: "false", label: "No" }
  ];
  // const [isOpen, setIsOpen] = useState();

  useEffect(
    function onValueChange() {
      setCurrentValue(value ? "true" : "false");
      // setIsOpen(false);
      selectRef.current && selectRef.current.blur();
    },
    [value, row, pos]
  );

  return (
    <Base
      {...props}
      ref={baseRef}
      onEditing={(e) => {
        selectRef.current.focus();
        // setIsOpen(true);
      }}
      type="boolean"
    >
      {column.readOnly && <BooleanReadOnly column={column} value={value} />}
      {!column.readOnly && (
        <SingleSelectDropdown
          value={currentValue}
          dataSource={dataSource}
          labelRenderer={(value) => {
            return value.label;
          }}
          itemRenderer={(item) => {
            return <DropdownItem>{item.label}</DropdownItem>;
          }}
          ref={selectRef}
          onOpen={() => {
            baseRef.current.startEditing(currentValue);
          }}
          onChange={(value) => {
            baseRef.current.dataChanged(value._id === "true");
            baseRef.current.dataCompleted();
          }}
          type={DROPDOWN_TYPE.MINIMAL}
          className={styles.yesno}
        />
      )}
    </Base>
  );
}

Boolean.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  row: PropTypes.any,
  pos: PropTypes.any
};
